import axios from 'axios';
import { IDatabase } from '../../../database';
import { IRealmFormGizmo, IUserV2 } from '../../../types';

interface IParams {
  apiUrl: string;
  database: IDatabase;
  user: IUserV2;
}

/**
 * Ask servers for configuration versions and return the ones that need to be downloaded
 *
 * @param {string} apiUrl server url
 * @param {IDatabase} database database instance
 * @param {IUserV2} user user object
 *
 * @returns
 */
async function getRootGizmoFidsToDownload({ apiUrl, database, user }: IParams) {
  const fidsToDownload: string[] = [];
  let fidsToRemove: string[] = [];

  if (user.credentials) {
    const credentials: any = user.credentials;
    const pingUrl = `${apiUrl}/main_api/v1/ping/`;

    try {
      const response = await axios.post(
        pingUrl,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            ...credentials,
          },
        }
      );

      if (response.status === 200) {
        const { forms } = response.data;

        const savedForms = await database.search({
          type: 'forms',
          params: {},
        });
        const uniqueFidsSet = new Set<string>();
        for (const savedForm of savedForms) {
          uniqueFidsSet.add(savedForm.id);
        }

        for (const form of forms) {
          let downloadForm = false;

          try {
            const savedForm = savedForms.find(
              (f: IRealmFormGizmo) => f.formGizmo.id === form.id
            );

            if (savedForm.version !== form.version) {
              downloadForm = true;
            }
          } catch (e) {
            // This means the form hasn't been saved yet
            downloadForm = true;
          }

          if (downloadForm) {
            uniqueFidsSet.add(form.id);
            fidsToDownload.push(form.id);
          }
        }

        fidsToRemove = Array.from(uniqueFidsSet).filter((fid: string) => {
          // If a fid is not present in the forms array, it means that form is no longer
          // assigned to the user.
          const fidPresent = forms.find((f: any) => f.id === fid);
          return !fidPresent;
        });
      }
    } catch (e) {
      // TODO: handle the ping error
    }
  }

  return { fidsToDownload, fidsToRemove };
}

export default getRootGizmoFidsToDownload;
